"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ITEM SELECTOR LIST : STYLES --------------- ++++++++++ */


var _default = {
  itemselectorlists: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .itemselectorlist': {
      flex: '1',
      marginRight: function marginRight(props) {
        return props.marginRight ? (0, _index.replacePXinStringWithEM)(props.marginRight) : '8%';
      },
      '&:last-child': {
        marginRight: '0'
      },
      '& h2': {
        display: 'flex',
        alignItems: 'center',
        fontSize: (0, _index.pxToEm)(16),
        fontWeight: 'bold !important',
        marginBottom: (0, _index.pxToEm)(20),
        '& .icon': {
          fontSize: '200%',
          marginRight: (0, _index.pxToEm)(7)
        }
      },
      '& .itemlist': {
        background: 'rgb(255, 255, 255)',
        borderRadius: '0',
        border: (0, _index.replacePXinStringWithEM)("1px solid rgb(239, 239, 239)"),
        minHeight: (0, _index.pxToEm)(360),
        maxHeight: (0, _index.pxToEm)(560),
        // minWidth: pxToEm(370),
        padding: (0, _index.replacePXinStringWithEM)('15px 20px 20px'),
        display: 'flex',
        flexDirection: 'column',
        '& .searchbar': {
          marginBottom: (0, _index.pxToEm)(20)
        },
        '& .items': {
          flex: '1',
          overflow: 'auto',
          '& .item': {
            cursor: 'pointer',
            userSelect: 'none',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            transition: 'all .15s linear 0s',
            padding: (0, _index.pxToEm)(10),
            '& .text': {
              flex: '1'
            },
            '&:hover': {
              background: 'rgb(242, 244, 248)'
            },
            '&.selected': {
              color: 'rgb(120, 189, 83)',
              fontWeight: 'bold',
              '& .icon': {
                color: 'rgb(120, 189, 83)'
              }
            }
          }
        }
      },
      '&.allitems': {
        '& .item': {
          '& .icon': {
            color: 'rgb(170, 170, 170)'
          }
        }
      },
      '&.selecteditems': {
        '& .item': {
          '& .icon': {
            '&:first-child': {
              color: 'rgb(120, 189, 83)',
              marginRight: (0, _index.pxToEm)(25)
            },
            '&:last-child': {
              color: 'rgb(105, 107, 110)',
              transition: 'color .15s linear 0s'
            }
          },
          '&:hover': {
            '& .icon': {
              '&:last-child': {
                color: '#DF1D1D'
              }
            }
          }
        }
      }
    }
  }
};
exports.default = _default;